import React, { Fragment, useState } from 'react';
import PayrollStaffListView from '../../../components/payroll/report/staff/PayrollStaffListView';
import AppURL from '../../../constants/AppURL';
import useFetchData from '../../../helpers/useFetch';

const PayrollStaffListReportView = () => {
    const [onURL, setOnURL] = useState(AppURL.PayrollURL + 'payroll/staff/report/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);
    const handleFormSuccess = (): void => {
        refetch();
    };
  return (
    <Fragment>
        <PayrollStaffListView loading={loading} data={data} setOnURL={setOnURL} error={error} handleFormSuccess={handleFormSuccess} />
    </Fragment>
  )
}

export default PayrollStaffListReportView